import { render, staticRenderFns } from "./EditDriverBusModal.vue?vue&type=template&id=4453ca62&"
import script from "./EditDriverBusModal.vue?vue&type=script&lang=js&"
export * from "./EditDriverBusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports